import React, { useState } from "react";
import Ideadox from "../../logos/Ideadox.svg";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Star from "../../logos/Star.svg";
import { caseStudies2 } from "../CaseStudy";
import CaseStudyCard from "../CaseStudyCard";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";
import { isMobile } from "react-device-detect";

const CaseStudy11 = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const displayedCaseStudies = caseStudies2.slice(0, 3);

  return (
    <div
      style={{
        backgroundColor: "#F0DFD8",
        padding: "2rem",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        overflowX: "hidden",
        overflow: "hidden",
      }}
    >
      <header
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          padding: "1rem",
          boxSizing: "border-box",
          top: 5,
          position: "absolute",
        }}
      >
        <div
          onClick={() => navigate("/caseStudy")}
          style={{ cursor: "pointer" }}
        >
          <img src={Ideadox} alt="Ideadox" />
        </div>
        {isMobile ? (
          <div>
            <Button
              className="border border-black mt-2 rounded-full"
              onClick={handleMenuOpen}
            >
              <MenuIcon />
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              sx={{
                "& .MuiPaper-root": {
                  backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent white
                  boxShadow: "none",
                },
              }}
            >
              <MenuItem
                onClick={handleMenuClose}
                style={{
                  color: "#000",
                  fontFamily: "Golos Text",
                }}
              >
                Blog
              </MenuItem>
              <MenuItem
                onClick={() => navigate("/caseStudy")}
                style={{
                  color: "#000",
                  fontFamily: "Golos Text",
                }}
              >
                Case Study
              </MenuItem>
              <MenuItem
                onClick={() => navigate("/aboutus")}
                style={{
                  color: "#000",
                  fontFamily: "Golos Text",
                }}
              >
                About
              </MenuItem>
            </Menu>
            <button className="border border-black py-1 px-2 mt-2 rounded-full hover:bg-black hover:text-white">
              Get In Touch
            </button>
          </div>
        ) : (
          <nav className="space-x-4 mr-4">
            <button
              className="hover:underline"
              onClick={() => {
                /* handle click */
              }}
            >
              Blog
            </button>
            <button
              className="hover:underline"
              onClick={() => {
                navigate("/caseStudy");
              }}
            >
              Case Study
            </button>
            <button
              className="hover:underline"
              onClick={() => navigate("/aboutus")}
            >
              About
            </button>
            <button className="border border-black py-1 px-3 rounded-full hover:bg-black hover:text-white">
              Get In Touch
            </button>
          </nav>
        )}
      </header>
      <Typography
        style={{
          fontFamily: "Bricolage Grotesque",
          fontWeight: 600,
          fontSize: isMobile ? "24px" : "48px", // Adjust font size for mobile
          color: "#2F2F30",
          lineHeight: isMobile ? "30px" : "65px", // Adjust line height for mobile
          textAlign: "left",
          marginTop: isMobile ? "80px" : "70px", // Adjust margin for mobile
          maxWidth: isMobile ? "100%" : "50%", // Adjust width for mobile
          overflowWrap: "break-word",
        }}
      >
        Building a Secure and Compliant Product Aligned with User Expectations
      </Typography>
      <div
        className={`flex flex-col items-start px-8 ${
          isMobile ? "mt-6" : "mt-2"
        }`}
        style={{
          marginRight: isMobile ? "50%" : "40%",
        }}
      >
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "28px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "35px",
          }}
        >
          Background
        </Typography>
      </div>
      <div>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 350,
            fontSize: isMobile ? "20px" : "20px",
            color: "#78787A",
            width: isMobile ? "110%" : "741px",
            marginTop: "10px",
            marginLeft: isMobile ? "-2%" : "",
            textAlign: "left",
          }}
        >
          Client E’s product, a data analytics platform, needed to adhere to
          strict data security and compliance standards (GDPR, CCPA) to ensure
          user trust and regulatory alignment. However, limited knowledge of
          compliance requirements led to vulnerabilities and potential risks
        </Typography>
      </div>
      {!isMobile && (
        <div className="fixed top-28 left-20 h-1/2 w-64 p-2">
          <Typography
            style={{
              fontFamily: "Golos Text",
              fontSize: "22px",
              fontWeight: 600,
              color: "#2F2F30",
              textAlign: "left",
            }}
          >
            CONTENTS
          </Typography>
          <ul>
            <li>
              <Typography
                align="left"
                style={{
                  marginTop: "8px",
                  fontFamily: "Golos Text",
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#78787A",
                }}
              >
                Background
              </Typography>
            </li>
            <li>
              <Typography
                align="left"
                style={{
                  marginTop: "8px",
                  fontFamily: "Golos Text",
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#78787A",
                }}
              >
                CPO Approach & Solution
              </Typography>
            </li>
            <li>
              <Typography
                align="left"
                style={{
                  marginTop: "8px",
                  fontFamily: "Golos Text",
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#78787A",
                }}
              >
                Impact
              </Typography>
            </li>
          </ul>
        </div>
      )}
      <div
        className="flex flex-col items-start mt-2"
        style={{
          marginRight: isMobile ? "45%" : "9%",
          width: isMobile ? "60%" : "40%",
        }}
      >
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
            width: isMobile ? "160%" : "",
          }}
        >
          CPO Approach & Solution
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "170%" : "850px",
          }}
        >
          As the acting CPO for Client E, IDEADOX led the team in a
          comprehensive transformation to boost technical efficiency.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
            width: isMobile ? "170%" : "90%",
          }}
        >
          Establishing a Compliance-Focused Product Development Framework:
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          IDEADOX implemented a compliance framework that outlined clear data
          security and user privacy practices. We trained Client E’s team on
          these standards, ensuring that product development adhered to legal
          requirements and that user data was protected.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
            width: isMobile ? "170%" : "90%",
          }}
        >
          User-Centered Security Enhancements
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          To reinforce user trust, we added visible security features, such as
          two-factor authentication and consent-based data handling, aligning
          the product with best practices in data security. This focus on
          user-centered security improvements helped reassure users about the
          product’s reliability and integrity. .
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
            width: isMobile ? "170%" : "90%",
          }}
        >
          Continuous Compliance Monitoring and Iterative Updates
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          We set up a monitoring system to identify compliance risks and
          conducted regular audits to ensure ongoing alignment with regulatory
          updates. This proactive approach ensured that the product remained
          compliant over time without requiring costly, reactive changes.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "28px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
          }}
        >
          Impact
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          •{" "}
          <span
            style={{
              color: "#2F2F30",
            }}
          >
            Increased client trust
          </span>{" "}
          and retention due to secure, transparent data practices.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          •{" "}
          <span
            style={{
              color: "#2F2F30",
            }}
          >
            100% regulatory compliance
          </span>{" "}
          achieved within three months, reducing potential legal risks. .
        </Typography>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center", // Center horizontally
            marginTop: "60px",
            width: isMobile ? "160%" : "140%", // Ensure it takes full width
          }}
        >
          <img src={Star} alt="Star" style={{ marginRight: "0.5rem" }} />
          <Typography
            style={{
              fontSize: 28,
              fontFamily: "Bricolage Grotesque",
              fontWeight: 200,
              color: "#2F2F30",
            }}
          >
            Case Study
          </Typography>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center", // Center horizontally
            width: "140%", // Ensure it takes full width
          }}
        >
          <Typography
            style={{
              fontFamily: "Golos Text",
              fontSize: isMobile ? "26px" : "34px",
              fontWeight: 600,
              textAlign: "center",
              marginTop: "40px",
              marginLeft: isMobile ? "17%" : "",
            }}
          >
            Read More
          </Typography>
        </div>
        <div
          className="case-studies-list"
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "40px",
            marginTop: "20px",
            flexDirection: isMobile ? "column" : "row", // Change direction for mobile
            alignItems: isMobile ? "center" : "flex-start", // Center items on mobile
            marginLeft: isMobile ? "12%" : "",
          }}
        >
          {displayedCaseStudies.map((study, index) => (
            <div
              key={index}
              style={{
                width: "300px", // Set a consistent width
                padding: "16px",
              }}
            >
              <CaseStudyCard
                title={study.title}
                link={study.link}
                image={study.image}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CaseStudy11;
